import React from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function DetailModal({
  isOpen,
  onClose,
  title,
  children
}: DetailModalProps) {
  return createPortal(<AnimatePresence data-id="element-48">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999]" onClick={onClose} data-id="element-49" />
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 md:p-8 pointer-events-none" data-id="element-50">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.4
        }} className="w-full md:w-[640px] max-h-[80vh] glass-border rounded-[20px] overflow-hidden flex flex-col pointer-events-auto" data-id="element-51">
              <div className="flex items-center justify-between px-6 py-4 border-b border-border-subtle shrink-0" data-id="element-52">
                <h3 className="text-sm font-heading text-text-primary" data-id="element-53">
                  {title}
                </h3>
                <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/5 transition-colors text-text-secondary hover:text-text-primary" data-id="element-54">
                  <X size={16} data-id="element-55" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-6" data-id="element-56">{children}</div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>, document.body);
}